import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useStoreState } from "ezStore";
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";

import { Button, PageHeader } from "@cofano/cck";
import { CircularProgress } from "@mui/material";

import Helmet from "components/helmet/Helmet";
import { hasPluginPermission, Language, usePermission } from "imports/Utils";
import { VoyageInfo } from "view/voyages/components/details/VoyageInfo";

import { VoyageDetailsDocument } from "__generated__/view/voyages/graphql/voyage.queries.generated";

const VoyageDetails = () => {

	const session = useStoreState((store) => store.session);
	const navigate = useNavigate();
	const { id } = useParams();

	const { isAdmin, isCompanyUser, isMainUserLimited, isReadOnly } = usePermission();
	const hasEditPermission = !isReadOnly && (isAdmin || isCompanyUser || isMainUserLimited);

	const { data, refetch } = useQuery(VoyageDetailsDocument, {
		variables: {
			id: Number(id),
		},
	});

	return (
		<React.Fragment>
			{data?.voyage ? (
				<div>
					<PageHeader>
						<PageHeader.Title>
							{Language("VOYAGE")}
							<Helmet title={intl.formatMessage({ id: "VOYAGE" })} />
						</PageHeader.Title>

						<PageHeader.Actions>
							{hasPluginPermission(session, "angler") && (data.voyage.calls.length > 0) && (
								<Button onClick={() => navigate(`/view/voyages/${data.voyage?.id}/plan`)} variant="outlined">
									{Language("ANGLER_VOYAGE_PLAN")}
								</Button>
							)}

							<Button onClick={() => navigate("/view/voyages")} variant="outlined">
								{Language("VOYAGES")}
							</Button>

							{hasEditPermission && (
								<Button onClick={() => navigate(`/view/voyages/${data.voyage?.id}/edit`)}>
									{Language("EDIT")}
								</Button>
							)}
						</PageHeader.Actions>
					</PageHeader>

					<VoyageInfo voyage={data.voyage} refetch={refetch} />
				</div>
			) : (
				<CircularProgress size={30} />
			)}
		</React.Fragment>
	);
};

export default VoyageDetails;
